<template>
	<div class="newpage">
		<div class="printTest-box">
			<div id="printTest">
				<div style="display: flex;flex-direction: column;align-items: center;">
				    <div >
						<loading class="loading_style" :tip="tip" v-if="!th_printdata.length"></loading>
						<div ref="menuItem" v-else>
							<div    :style="item.genre === 'order' ? sliderStyle : sliderStyleCopy"     v-for="(item,index) in listCopy" :key="index">
								<div v-if="item.genre === 'order' " >
									<div style="width: 100%;display: flex;justify-content: space-between;">
										 <span class="desc">{{item.printNum+1}}st print</span>
										 <span class="desc">{{item.genre}}</span>
										 <span class="desc">NO.{{item.NO+1}}</span>
									</div>
									<div class="loading-box" v-if="!item.image">
										<!-- <i class="el-icon-loading"></i>
										<span style="font-size: 18px;">loading...</span> -->
										<div class="desc_failed">{{$t('other.a496')}}</div>
										
									</div>
									<div   style="width: 100%;overflow: hidden;">
										<div  >
											<img  style="width: 100%;"  :src='item.image' />
										</div>
									</div>
									<!-- <div style="page-break-after:always"></div> -->
								</div>
								<!-- 拣货单	 -->
								<div style="box-sizing: border-box;padding: 5px 10px;" v-if="item.genre === 'picklist' ">
									<div style="width: 100%;display: flex;justify-content: space-between;">
										 <div>
											 <div >{{item.genre}}</div>
											 <div style="font-size: 12px;">buyer：{{item.buyerName}}</div>
											 <div style="font-size: 12px;">total：{{item.itemsCopy.length}}</div>
											 <div style="font-size: 12px;">print time：{{getTiem(item.printTime)}}</div>
										 </div>
										 <span >{{item.orderId}}</span>
									</div>
									<div style="border-bottom: 1px #000000 solid;padding: 5px 0 ;">
										 <span style="display: inline-block;width: 30px;">#</span>
										 <span style="display: inline-block;width: 73px;">Cuscode</span>
										 <span style="display: inline-block;width: 80px;">W_Sku</span>
										  <span style="display: inline-block;width: 80px;">Position</span>
										 <span style="display: inline-block;width: 30px;">Qty</span>
									</div>
			

									<div  style="display:flex;font-size: 10px; border-bottom: 1px solid #E0E0E0;padding: 3px 0;" v-for="(ccp,index01) in item.itemsCopy" :key="index01">
										 <span style="display: inline-block;width: 30px;">{{index01+1}}</span>


										 <div >
											<div style="display:flex"  v-for="(oop,index03) in ccp" :key="index03">
												
												<div>{{oop.cusCode}}</div>
												<div style="width:70px;word-break:break-all;padding:0 10px">{{oop.skuName}}</div>
												<div style="width:70px;word-break:break-all;padding:0 10px">{{oop.address}}</div>
												<div style="padding:0 10px">{{oop.rate * oop.purchaseNum}}</div>
												<div v-show="!oop.addition">{{oop.isComponent ? $t('other.a251') : $t('other.a252')}}</div>
												<div v-show="oop.addition">{{$t('other.a497')}}</div>
											</div>
										</div>

										 <!-- <span style="display: inline-block;width: 90px;word-break: break-all">{{ccp.cusCode}}</span>
										 <span style="display: inline-block;word-break: break-all;width: 90px;">{{ccp.skuName}}</span>
										 <span style="display: inline-block;width: 90px;word-break: break-all">{{ccp.address}}</span>
										 <span style="display: inline-block;">{{ccp.purchaseNum * ccp.rate}}</span> -->
									</div>

								


									<div style="font-size:14px">{{$t('other.a498')}}:{{item.messageToSeller ? item.messageToSeller : $t('other.a354')}}</div>
									<div style="font-size:14px">{{$t('other.a499')}}:{{item.note ? item.note : $t('other.a354')}}</div>
									
									
								</div>
								
							</div>
							
						</div>
					</div>
				</div>
				
				
				  
			</div>
			
			 
			
			
			
		</div>
		<div style="flex: 1;">
			    <div style="height: 200px;">
					<el-button style="margin: 20px 0 0 30px;" type="primary" v-print="'#printTest'"  @click="addPrintTime()">{{$t('other.a342')}}</el-button>
					<!-- <el-button id="pprint" style="margin: 20px 0 0 30px;" type="primary" @click="ttp()">{{$t('other.a342')}}</el-button> -->
					<!-- <button @click="start_print">开始打印</button> v-print="'#printTest'" -->
				</div>
				<div style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
					<div style="font-size: 14px;padding-left: 10px;">{{$t('other.a346')}}</div>
					 <el-select style="margin-left: 15px;" size="mini" v-model="value" :placeholder="$t('other.a50')" @change="chosePage()">
						<el-option
						  v-for="item in options"
						  :key="item.value"
						  :label="item.label"
						  :value="item.value">
						</el-option>
					 </el-select>
				</div>
				<div v-show="value == '10' "  style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
					<div style="font-size: 14px;padding-left: 10px;">{{$t('other.a347')}}</div>
					<el-input style="width:120px;padding-left:15px" @keyup.native="oop" size="mini" v-model="widthValue" :placeholder="$t('other.a319')"></el-input>
					<label style="font-size:14px;padding-left:10px">{{$t('other.a349')}}</label>
				</div>
				<div v-show="value == '10' "  style="display: flex;font-size: 14px;width: 100%;align-items: center;margin-bottom:15px">
					<div style="font-size: 14px;padding-left: 10px;">{{$t('other.a348')}}</div>
					<el-input style="width:120px;padding-left:15px" @keyup.native="oop1" size="mini" v-model="heightValue" :placeholder="$t('other.a319')"></el-input>
					<label style="font-size:14px;padding-left:10px">{{$t('other.a349')}}</label>
				</div>
			
		</div>
		
	</div>
	
</template>
<script>
import utils from '../utils/utils'
import printApi from '../api/moudles/print.js'
import api from '../api/api'
import orderApi from '../api/moudles/order'
import loading from '../components/loading_2'



	import {
		mapState,
		mapMutations ,
	     mapActions,
	} from 'vuex'

	import pdf from 'vue-pdf'
import Loading from './loading.vue'
	export default {
	    data() {
	      return {
	        th_printdata:[],
			barcodeValue:123,
			orderList:[],
			storeItemList:[],
			tip:this.$t('other.a500'),
			arr:[],
			options: [{
			          value: 1,
			          label: this.$t('other.a493')
			        }, {
			          value: 2,
			          label: this.$t('other.a494')
			        }, {
			          value: 3,
			          label: this.$t("other.a350")
			        }, {
			          value: 4,
			          label: this.$t("other.a351")
			        }],
					value:3,
					sliderStyle:{
						'width':'98mm',
						'height':'130mm',
						'background-color': '#fff',
						'margin-top':'10px',
						'position':'relative',
						"page-break-after":"always"
					},

					sliderStyleCopy:{
						'width':'98mm',
						'min-height':'130mm',
						'background-color': '#fff',
						'margin-top':'10px',
						'position':'relative',
						"page-break-after":"always"
					},
					widthValue:'100mm',
					heightValue:'150mm',
					checked:false,
					options: [{
					          value: '10',
					          label: this.$t("other.a350")
					        }, {
					         value: '20',
					         label: 'A4'
					        }, {
					          value: '30',
					          label: 'A5'
					        }, ],
					        value: '10',
							loadingList:[],
							loadedList:[],
							currentPage2: 1,
							pageSize:10,
							chooseList:null,
							generateOrderId:[]
					
		  }
	    },
		components:{
			loading,
			pdf

			
		},
		computed:{
			...mapState({
				picklist: state => state.order.picklist,
				seller: state => state.login.userInfo.userId,
				buttonMapList: state => state.print.buttonMapList,
				toPrintOrders: state => state.common.toPrintOrders,
			}),

			
			
			listCopy(){
				if(this.checked){
					let list=this.th_printdata
					let list2=list.slice((this.currentPage2 - 1) * this.pageSize, (this.currentPage2) * this.pageSize)
					console.log(list2)
				
					this.chooseList=list2
					return list2
				}else{
					return this.th_printdata
				}
			},
		
			
		},
		watch:{
			listCopy(){
				console.log(this.listCopy)
			},
			storeItemList(){
				let list=this.orderList
				let storeItem=this.storeItemList
		
				list.forEach(p => {
					p.items.forEach(i => {
						i.storeItem=storeItem[i.itemId+'_' +i.variationId]
					})
				})
				console.log('list',list)
				this.th_printdata=list
				
			},
		},
		created(){
	        // this.src=pdf.createLoadingTask(this.src)
			this.getOrdersByOrderId()
			
		},
	
		methods:{
			...mapActions('order', [
				'getUnprocessOrder',//获取所有商店待处理订单
				'auditOrder',
				'getPrintOrder', //打印订单
				'getOrdersBytrickNo'
				
			]),
			...mapActions('print', [
				'addPrintNum',
			
			]),
			...mapMutations('print', [
				'SET_ITEMS',
				'SET_HAS_PRINTED',
				'SET_TTP',
				'SET_HAS_PRINTED_READY',
				'INIT_DATA',
				'FAST_PRINT',
				'UPDATA_PAGE',
				'SENT_PPT'
			]),
			getOrdersByOrderId(){
				let list=JSON.parse(localStorage.getItem('unprocessedOrderIds'))
				let itemID_variationId=JSON.parse(localStorage.getItem('itemID_variationId'))
				api
				.getOrderByOrderIds({orderIds:list})
				.then(res => {
					if(res.code === 200) {
						console.log('获取到订单数据',res.data)
						let originData=res.data
						orderApi
						.getstoreitembyid(itemID_variationId)
						.then(res => {
							if(res.code === 200) {
								console.log('获取到StoreItem',res.data)
								originData.forEach((p,index) => {
									p.NO=index
									p.items.forEach((i) => {
										
										i.storeItem=res.data[i.itemId+'_' +i.variationId]
									})
								})
							
								this.th_printdata=originData
								this.init()
							}
						})

						console.log('originData',originData)
						
						
					}
				})

				
			},
			init(){
				
				// this.th_printdata=this.toPrintOrders
				// let list1=JSON.parse(localStorage.getItem('printcontentOver5'))
				// let list2=JSON.parse(localStorage.getItem('printcontent'))
	
				// this.th_printdata=[...list1,...list2]
				
				this.arr=JSON.parse(JSON.stringify(this.th_printdata))
				console.log('arr',this.arr)
				
				this.arr.forEach(p => {
				  let list3=[]
					p.itemsCopy=[]
					if(p.items.length > 0){
						p.items.forEach(k => {
							if(!k.storeItem || !k.storeItem.children  ||  k.storeItem.component){//判断items里的每个item是不是套餐，不是才push
								
								k.cusCode=k.storeItem ? k.storeItem.cusCode : this.$t("other.a354")
								k.skuName=k.storeItem ? k.storeItem.skuName : this.$t("other.a354")
								k.address=k.storeItem ? k.storeItem.address : this.$t("other.a354")
								k.purchaseNum=k.variationQuantityPurchased
								k.rate=1
								p.itemsCopy.push([k])
								k.isComponent=true
						    }
							
							if(k.storeItem && k.storeItem !== null){
								if(k.storeItem.additions.length> 0){
									let arr2=[]
									k.storeItem.additions.forEach(p => {
										p.purchaseNum=k.variationQuantityPurchased
										arr2.push(p)
									})

									list3.push(arr2)
								}
							}

						
							if(k.storeItem && k.storeItem !== null && k.storeItem.children){
								if(k.storeItem.children.length>0 && !k.storeItem.component){
									k.isComponent=false
									let list2=[]
									k.storeItem.children.forEach(i => {
										i.purchaseNum=k.variationQuantityPurchased
									
										list2.push(i)
									})
									list3.push(list2)
									
								}
							}
						})
					}

					if(list3.length){
						list3.forEach(i => {
							p.itemsCopy.push(i)
						})
					}
						
				})

				
				
				console.log('arr2',this.arr)
				
				this.th_printdata.forEach(p =>{
					p.genre='order'
				})
				
				
				this.arr.forEach(p => {
					p.genre='picklist'
				})
			
				this.th_printdata=[...this.th_printdata,...this.arr]
				this.th_printdata.sort((a,b) => {return a.NO-b.NO })
				
				console.log(this.th_printdata)
				
				
				
				
			},
			addPrintTime(){
				let arr = []
				this.listCopy.forEach(p => {
					if(p.trackingNo !== "" && p.image!== null) {
						arr.push(p.orderId) 
					}
					
				})
				console.log(arr)
				this.addPrintNum(arr)
			},
			
			 start_print(){
			        this.$print(this.$refs.dfbfjj);//$refs的值要和html里的ref一致
			    },
			
			
			handleSizeChange(val) {
			        console.log(`每页 ${val} 条`);
					this.pageSize=parseInt(`${val}`)
			      },
			handleCurrentChange(val) {
				
				this.currentPage2=parseInt(`${val}`)
				console.log(this.chooseList);
				this.getPirntPdf()
				
				
			},
			//开启分批打印时，触发面单再次请求
			getPirntPdf(){
				setTimeout(() => {
					console.log(this.chooseList)
					let arr=this.chooseList.map(p => {
						return p.logisticInfo && p.trackingNo === ''?  JSON.parse(p.logisticInfo.info_needed.methods) : null
					})
					arr=utils.unique(arr)
					arr[0] === null ? arr.splice(0,1) : arr[0]
					
					this.generateOrderId=arr.map(p => {
						if(p !== null) {
							return p.orderId
						}
					})
					
					console.log(arr)
					console.log(this.generateOrderId)
					if(this.generateOrderId.length){
						console.log(8888)
						printApi
						.startReadyOrders(arr)
						.then(res => {
							if(res.code === 200) {
								console.log('发送订单请求',res.data)
								this.getNewOrderList(this.generateOrderId)
							}
						})
					}
				
				},1000)
			},
			
			//获取最新的面单
			getNewOrderList(arr){
				printApi
				.getNewOrders(arr)
				.then(res => {
					if(res.code === 200){
						console.log('获取到最新的订单',res.data)
						let newData=res.data
						newData.forEach(p => {
							this.th_printdata.forEach(i => {
								if(i.orderId == p.orderId && p.image !== null && p.ready == true){
									i.image=p.image
								}
							})
							this.generateOrderId.forEach((k,index) => {
								if(k === p.orderId && p.ready == true && p.image!== null){
									this.generateOrderId.splice(index,1)
								}
							})
						})
						
						if(this.generateOrderId.length> 0){
							this.getNewOrderList(this.generateOrderId)
						}
					}
				})
			},
			
			chosePage(){
				console.log(this.value)
				if(this.value == '20'){
					this.sliderStyle.width='210mm'
					this.sliderStyle.height='297mm'
				}else if(this.value == '30'){
					this.sliderStyle.width='148mm'
					this.sliderStyle.height='210mm'
				}else if(this.value == '10'){
					this.sliderStyle.width='100mm'
					this.sliderStyle.height='150mm'
					this.widthValue='100'
					this.heightValue='150'
				}
			},

			refreshOrder(item){
				console.log(item)
				printApi
				.startReadyOrders({
					userId:this.userId,
					type:0,
					orderId:item.orderId
				})
				.then(res => {
					if(res.code === 200) {
						console.log('重新加载面单',res.msg)
					}else{
						this.$message.warning(res.msg)
					}
				})
			},
			
			oop1(){
				
				this.sliderStyle.height=this.heightValue + 'mm'
			},
			oop(){
				console.log(this.widthValue)
				this.sliderStyle.width=this.widthValue + 'mm'
			},
			//深拷贝数组
			copy (obj) {
			        var newobj = []
			        if(typeof obj !== 'object'){
			            return;
			        }
			        for(var i in obj){
			           newobj[i] = typeof obj[i] === 'object' ? this.copy(obj[i]) : obj[i];
			        }
			        return newobj
			},
			//从storage上拿下将要打印的item
			
			
		
			
		     ttp(){
				var headstr = "<html><head><title></title></head><body>";
				var footstr = "</body>";
				var newstr = this.$refs.menuItem.innerHTML;
				const oldstr = document.body.innerHTML;
				document.body.innerHTML = headstr+newstr+footstr;
				setTimeout(() => {
					document.body.innerHTML = oldstr;
				},1000)
				window.print(); 
				return false
			
			
			},
		
			
			
			getTiem(time) {
				
				if(typeof(time) ==Array ){
					return 'pending update'
				}else{
					
					return utils.renderTime(time)
				}
				
				
			},
		}
	  }
</script>

<style>



	
	.newpage{
		width: 100%;
		background: #fff;
		z-index: 99999;
		display: flex;
		position: absolute;
		/* display: flex;
		flex-direction: column;
		justify-content: center; */
	
	}

	.newpage .item_order_desc{
		padding-right:3px;

	}
	
	
	@page
	{ 
		margin: 0mm 0mm 0mm 0mm;  
	}
	@page:first
	{ 
		margin-top: -5mm ;  
	}
	
	
	.pic-box{
	  width: 100%;
	  image-rendering:-moz-crisp-edges;
	  image-rendering:-o-crisp-edges;
	  image-rendering:-webkit-optimize-contrast;
	  image-rendering: crisp-edges;
	  -ms-interpolation-mode:nearest-neighbor;
	 }
	
	.newpage .pick-list-wrpper{
		width: 100%;
		
		font-size: 12px;
		position: relative;
	}
	
	.orderpage-btn{
		width: 800px;
		margin: 0 auto;
		display: flex;
		justify-content: flex-end;
		padding: 10px 0;
	}
	
	.newpage .print-area{
		
		
		margin-bottom: 200px;
		
		
	}
	.desc-info{
		width: 798px;
		
		border: 2px #000000 solid;
	}

	.newpage .loading-box{
		position: absolute;
		top: 0;
		right: 0;
		left: 0;
		bottom: 0;
		margin: auto;
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	
	.newpage .orderpage-poo-box{
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		padding-bottom: 5px;
		border-bottom: 2px #000000 dashed
	}

	.newpage .desc_failed{
		padding: 8px 0;
		text-align: center;
		color: rgb(152 148 148)
	}
	
	.newpage  .orderpage-poo{
		min-width: 265px;
		height: 40px;
		border: 2px solid #000000;
		text-align: center;
		line-height: 40px;
		font-size: 18px;
		font-weight: bold;
		margin: 5px 10px;
	}
	
	.newpage  .receipt-item{
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		padding:5px 10px;
	}
	
	.newpage  .receipt-item .area {
		display: inline-block;
		width: 50%;
		font-size: 18px;
	}
	
	.newpage  .desc-info-left-text{
		font-size: 18px;
		font-weight: bold;
		padding-right: 30px;
	}
	
	.newpage  .desc-info-footer{
		display: flex;
		justify-content: space-between;
		box-sizing: border-box;
		padding: 5px 10px;
	}
	
	.newpage  .tto{
		display: inline-block;
		width: 200px;
		text-align: center;
		box-sizing: border-box;
		padding: 5px;
	}
	.newpage  .tto01{
		display: inline-block;
		width: 100px;
	}
	.newpage  .cco{
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		border-bottom: 1px #000000 solid;
		box-sizing: border-box;
		padding: 0 10px;
	}
	
	.newpage  .city-tap{
		display: inline-block;
		padding: 5px;
		border: 2px solid #000000;
		margin: 5px 0;
		padding: 5px 15px;
		font-size: 18px;
	}
	
	.newpage  .city-tap01{
		display: inline-block;
		padding: 5px;
		border: 2px solid #000000;
		margin: 5px 5px;
		font-size: 18px;
		padding: 5px 15px;
	}


	
	
	
	
	.newpage  .desc{
		/* position: absolute;
		top: 40%;
		left: 25%;
		bottom: 0;
		right: 0;
		margin: auto; */
		font-size: 18px;
		font-weight: bold;
		color: red;
		opacity: 0.3;
		
		
		
	}
	.newpage  .oook{
		margin-bottom: 20px;
		
	}
	

	
/* 	.pp-wrapper{
		position: absolute;
		left: 0;
		right: 0;
		margin: 0 auto;
	}	 */
	
	.newpage  .printTest-box{
		width: 80%;
		overflow-y: auto;
		height: 100vh;
		background-color: #000;
		position: relative;
	
	}
	
	.newpage  .page-box{
		/* width: 800px;
		height: 670px; */
		overflow: hidden;
		background-color: #fff;
		/* position: absolute;
		left: 0;
		right: 0;
		margin: 0 auto; */
		
	}
	
	.newpage .el-icon-loading:before {
	    content: "\E6CF";
	    font-size: 60px;
	}

	.newpage .loading_style{
		background-color: #454040;
		position: absolute !important;
		width: 100%;
		height: 100vh;
		left: 0;
		
	}


	
	.el-popper{
		z-index: 999999!important;
	}
	
	.img-wrapper{
	  width: 1100px;
	  height: 1188px;
	  margin: -369.5px -354.5px;
	  transform: scale(0.36);
	}
	
	.fenpi{
		display: flex;
		align-items: center;
		width: 100%;
		height: 50px;
		line-height: 50px;
		background-color: #fff;
		position: fixed;
		bottom: 0;
		z-index: 999999;
		font-size: 14px;
		padding-left: 15px;
	}
	
	.fenpi-item{
		margin-right: 10px;
	}
	
	
	
</style>
